import React, { memo } from 'react';
import { Box, Tooltip } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import OutputIcon from '@mui/icons-material/Output';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { IPD_COLORS } from '../../theme';

const FLAGS = [
  { key: 'is_receiving_store', label: 'Receiving', icon: LocalShippingIcon, color: IPD_COLORS.primary },
  { key: 'is_issue_store', label: 'Issue', icon: OutputIcon, color: IPD_COLORS.success.text },
  { key: 'is_pharmacy_store', label: 'Pharmacy', icon: LocalPharmacyIcon, color: IPD_COLORS.warning.text },
  { key: 'is_non_stock', label: 'Non-stock', icon: Inventory2Icon, color: IPD_COLORS.textSecondary },
];

function StoreFlagBadges({ store, size = 18, showInactive = false }) {
  if (!store) return null;
  const active = FLAGS.filter(f => store[f.key]);
  if (!active.length && !showInactive) {
    return <Box component="span" sx={{ color: IPD_COLORS.textSecondary, fontSize: 13 }}>—</Box>;
  }
  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', flexWrap: 'wrap' }}>
      {FLAGS.map(({ key, label, icon: Icon, color }) => {
        const on = !!store[key];
        if (!on && !showInactive) return null;
        return (
          <Tooltip key={key} title={on ? label : `${label} (off)`}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: size + 8,
                height: size + 8,
                borderRadius: '6px',
                backgroundColor: on ? `${color}18` : IPD_COLORS.panelHeaderBg,
                border: `1px solid ${on ? color : IPD_COLORS.border}`,
                opacity: on ? 1 : 0.45,
              }}
            >
              <Icon sx={{ fontSize: size, color: on ? color : IPD_COLORS.textSecondary }} />
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
}

export default memo(StoreFlagBadges);
